export enum CourseTypeEnum {
    AnnualMandatory = 'annual mandatory',
    Practice = 'practice'
}